import { styled, Typography } from '@material-ui/core';
import { COLOR_TEXT_MAIN } from '../../../../theme/colors';

// https://www.figma.com/file/oy0lqfg1RnOZ1Y7129AJmc/KAIZEN-Design-Library?node-id=40%3A11173
const DescriptionBold = styled(Typography)({
  fontWeight: 700,
  fontSize: '14px',
  fontStyle: 'normal',
  color: COLOR_TEXT_MAIN,
  lineHeight: '160%',
  letterSpacing: '0.01em',
  '&.Mui-focused': {
    color: COLOR_TEXT_MAIN,
  },
});
export const DescriptionBoldStyle = {
  fontWeight: 700,
  fontSize: '12px',
  fontStyle: 'normal',
  color: COLOR_TEXT_MAIN,
  lineHeight: '160%',
  letterSpacing: '0.01em',
  '&.Mui-focused': {
    color: COLOR_TEXT_MAIN,
  },
};
export default DescriptionBold;
